import styled from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';
import { fontWeightBold, regularWhite } from '../../../../ui-components/design-tokens';
import { playFontSize } from '../../../../ui-components/typography/helpers';
import { PlayTextStyles } from '../../../../ui-components/typography/PlayText/PlayText.styles';
import { Uppercase } from '../../../../ui-components/typography/PlayUppercase.styles';
import { VisuallyHidden } from '../../../../ui-components/utils.styles';

export const MetadataContainer = styled.div`
    @media ${device.GteSmall} {
        margin-top: -20px;
    }
`;

export const MetadataHeader = styled.h2`
    ${VisuallyHidden}
`;

// Seems to be sort of ok to wrap dt/dt with a div
// https://html.spec.whatwg.org/multipage/grouping-content.html#the-dl-element
export const MetadataKeyValue = styled.div`
    margin: 10px 0 10px 0;
    width: 50%;

    &:first-of-type {
        margin-left: 0;
    }

    @media ${device.GteSmall} {
        width: 100%;
        margin: 20px 0 0 0;
    }

    @media ${device.GteMedium} {
        width: 50%;
        margin-top: 20px;
    }
`;

export const StyledMetadata = styled.dl`
    margin: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    margin-top: 20px;
    margin-bottom: 0;

    @media ${device.GteSmall} {
        margin-top: 0;
        margin-bottom: 0;
    }

    @media ${device.GteMedium} {
        margin-left: 30px;
    }

    @media ${device.GteLarge} {
        margin-left: 0;
    }
`;

export const MetadataKey = styled.dt`
    ${Uppercase}
    display: block;
    ${playFontSize(1.4)}
    color: ${regularWhite};
    font-weight: ${fontWeightBold};
    margin-bottom: 2px;
`;

export const MetadataValue = styled.dd`
    ${PlayTextStyles}
    display: block;

    &:nth-child(1 + 1) {
        margin-top: 10px;
    }
`;
